import type { TFunction } from 'i18next';

/** TPP API エラーから表示メッセージを解決（code → i18n、なければ message） */
export function getTppApiErrorMessage(error: unknown, translate: TFunction): string {
  if (error && typeof error === 'object' && 'response' in error) {
    const errData = (
      error as { response?: { data?: { error?: { message?: string; code?: string } } } }
    ).response?.data?.error;
    if (errData?.code) {
      return translate(errData.code, { defaultValue: errData.message ?? errData.code });
    }
    if (errData?.message) return errData.message;
  }
  if (error instanceof Error && error.message !== 'missing') return error.message;
  return '';
}

export function tppMutationError(
  error: unknown,
  translate: TFunction,
  fallbackKey = 'tpp.action_failed'
): string {
  return getTppApiErrorMessage(error, translate) || translate(fallbackKey);
}
